import newBallons from './frontscreenballoons.svg'
import styles from './Images.module.css'

export const FrontScreenBalloons = () => {
    return (
    <img src={newBallons}
    alt = "Balloons Image"
    className={styles.mainScreenImage}
    />)
}